export class Currency {
  code: string;
  displayName: string;

  constructor(code: string, displayName: string) {
    this.code = code;
    this.displayName = displayName;
  }

  toString(): string {
    return `${this.code} - ${this.displayName}`;
  }
}
